<template>
  <div class="manage">
    <el-dialog :title="'授权'" :visible.sync="isShow">
      <common-form :formLabel="operateFormLabel" :form="operateForm" ref="form"></common-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
    <div class="manage-header">
      <common-form inline :formLabel="formLabel" :form="searchFrom">
        <el-button type="primary" @click="getList(searchFrom.keyword)" icon="el-icon-search">搜索</el-button>
      </common-form>
    </div>
    <authorization-table
      :tableData="tableData"
      :tableLabel="tableLabel"
      :config="config"
      @changePage="changePage"
      @authorize="authorize"
      @transferRole="transferRole"
    ></authorization-table>
  </div>
</template>

<script>
import CommonForm from '../../components/CommonForm'
import store from '../../store'
import AuthorizationTable from '../../components/AuthorizationTable'
import { pageAuthrizeInfoApi } from '../../api/getData'
import { addUserRoleApi } from '../../api/getData'
import { updateUserRoleApi } from '../../api/getData'
import { transferRoleApi } from '../../api/getData'

export default {
  components: {
    CommonForm,
    AuthorizationTable
  },
  data() {
    return {
      isShow: false,
      tableData: [],
      tableLabel: [
        {
          prop: 'username',
          label: '用户名'
        },
        {
          prop: 'customerName',
          label: '昵称'
        },
        {
          prop: 'realName',
          label: '用户实名'
        },
        {
          prop: 'idNo',
          label: '身份证/统一社会信用代码',
          width: 200
        },
        {
          prop: 'rolename',
          label: '角色名称'
        },
        {
          prop: 'accountType',
          label: '用户类型'
        },
        {
          prop: 'createTime',
          label: '注册时间',
          width: 200
        }
      ],
      config: {
        page: 1,
        size: 15,
        total: 0,
        loading: false
      },
      operateForm: {
        username: '',
        roleId: ''
      },
      operateFormLabel: [
        {
          model: 'username',
          label: '用户名',
          readonly: true
        },
        {
          model: 'roleId',
          label: '角色名称',
          type: 'select',
          options: [
            {
              value: '2',
              label: '销售合同管理员'
            },
            {
              value: '3',
              label: '印章管理员'
            },
            {
              value: '4',
              label: '销售合同用户'
            },
            {
              value: '5',
              label: 'HR企业用户'
            },
            {
              value: '6',
              label: 'HR个人用户'
            }
          ]
        }
      ],
      searchFrom: {
        keyword: ''
      },
      formLabel: [
        {
          model: 'keyword',
          label: '',
          placeholder: '用户名或昵称'
        }
      ]
    }
  },
  methods: {
    getList(val) {
      this.config.loading = true
      // 搜索时，页码需要设置为1，才能正确返回数据，因为数据是从第一页开始返回的
      val ? (this.config.page = 1) : ''
      //获取企业社会信用代码
      let organization = store.state.user.company.organization
      //调用人员信息查询接口
      pageAuthrizeInfoApi(this.config.page, this.config.size, val, val, organization).then(res => {
        res = res.data
        if (res.code === 0) {
          res = res.data
          this.tableData = res.data
          this.config.total = res.total
          this.config.size = res.pageSize
        } else {
          this.$message({
            type: 'warning',
            message: res.msg + '当前用户无权限访问'
          })
        }
        this.config.loading = false
      })
    },
    transferRole(row) {
      this.$confirm('此操作将移除当前账号权限，请谨慎操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          transferRoleApi(row).then(res => {
            res = res.data
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: res.data
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    authorize(row) {
      this.operateType = 'add'
      this.isShow = true
      this.operateForm = row
      if (row.rolename !== null) {
        this.operateType = 'edit'
      }
    },
    confirm() {
      if (this.operateType === 'add') {
        //调用添加角色接口
        addUserRoleApi(this.operateForm).then(res => {
          console.info(res.data)
          res = res.data
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '添加授权成功！'
            })
            this.isShow = false
            this.getList()
          } else {
            alert(res.msg)
          }
        })
      }
      if (this.operateType === 'edit') {
        updateUserRoleApi(this.operateForm).then(res => {
          console.info(res.data)
          res = res.data
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '修改授权成功！'
            })
            this.isShow = false
            this.getList()
          } else {
            alert(res.msg)
          }
        })
      }
      this.isShow = false
    },
    delUser(row) {
      console.info(row)
    },
    changePage(val) {
      this.config.page = val
      this.getList()
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="scss" scoped></style>
